class Social {
    share(_url, type) {
        const url = _url || location.href;
        let socialUrl = false;
        let popupName = 'share';

        switch (type) {
            case 'vk':
                socialUrl = `http://vk.ru/share.php?url=${url}`;
                popupName = 'share-vk';
                break;
            case 'fb':
                socialUrl = `http://www.facebook.com/share.php?u=${url}`;
                popupName = 'share-fb';
                break;
            case 'tw':
                socialUrl = `http://twitter.com/home?status=${url}`;
                popupName = 'share-tw';
                break;
            case 'od':
                socialUrl = `http://www.ok.ru/dk?st.cmd=addShare&st.s=1&st._surl=${url}`;
                popupName = 'share-od';
                break;
            case 'mm':
                socialUrl = `http://connect.mail.ru/share?share_url=${url}`;
                popupName = 'share-mm';
                break;
            case 'gp':
                socialUrl = `https://plus.google.com/share?url=${url}`;
                popupName = 'share-gp';
                break;
            default:
                break;
        }

        if (!socialUrl) {
            return;
        }

        const sharePopup = window.open(
            socialUrl,
            popupName,
            'width=700,height=500,top=0,left=0'
        );

        sharePopup.focus();
    }
}

export default new Social();
